// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/icons.css
// module id = 1293
// module chunks = 32